import React from 'react';
import { toAbsoluteUrl } from '../../utils';
import { BASE_URL } from '../../../config/environmentConfig';
import { BUTTON_TYPE, ButtonComponent } from '../../components/ButtonComponent';
import { LoginLayout } from '../../components/login/LoginLayout';

import './StripeDecline.css';
import '../login/Login.scss';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface Props {
}

const StripeCountryDecline: React.FC<Props> = props => {
    const handleReturnToStripe = (): void => {
        window.location.href = 'https://dashboard.stripe.com';
    };

    return (
        <LoginLayout>

            <div className="form-container">
                <a
                    href={BASE_URL.LOGIN_URL}
                    target="_blank"
                    className="login-logo-link d-block text-center mb-20 w-100"
                    rel="noreferrer"
                >
                    <img
                      className="cursor-pointer login-logo"
                      src={toAbsoluteUrl('/media/flex-logo-small.svg')}
                      alt="logo"
                    />
                </a>

                <div className="stripe-decline-container w-100">
                    <h2 className="mb-20 text-center">Not Available in Your Region (Yet!)</h2>
                    <p className="mb-10 text-center">Thank you for your interest in FlexFactor — but it looks like our app isn’t available in your country just yet.</p>
                    <p className="mb-20 text-center">We’re working hard to expand and hope to support your region soon.</p>

                    <div className="d-flex justify-content-center">
                        <ButtonComponent
                            buttonType={BUTTON_TYPE.DEFAULT_BLACK}
                            buttonName="Return to Stripe"
                            onButtonClick={handleReturnToStripe}
                            additionalClass="w-200px align-self-center"
                        />
                    </div>
                </div>
            </div>
        </LoginLayout>
    );
};

export default StripeCountryDecline;
